import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/nivel-jerarquico';

/**
 * GET all Niveles Jerarquicos
 * @returns {Promise<object[]>}
 */
export const getAllNivelesJerarquicos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET NivelJerarquico by ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getNivelJerarquicoByID = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST NivelJerarquico
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const createNivelJerarquico = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH NivelJerarquico
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const updateNivelJerarquico = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE NivelJerarquico
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteNivelJerarquico = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR NivelJerarquico
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarNivelJerarquico = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
